import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { About } from './components/About';
import { Audience } from './components/Audience';
import { Bonuses } from './components/Bonuses';
import { CostOfInaction } from './components/CostOfInaction';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { Guarantee } from './components/Guarantee';
import { Hero } from './components/Hero';
import { InsideLook } from './components/InsideLook';
import { Journey } from './components/Journey';
import { PricingCards } from './components/PricingCards';
import { SocialProof } from './components/SocialProof';
import { Tomos } from './components/Tomos';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-dark font-body text-center text-stone-light" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProof data-id="element-2" />
      <About data-id="element-3" />
      <Tomos data-id="element-4" />
      <Bonuses data-id="element-5" />
      <CostOfInaction data-id="element-6" />
      <Journey data-id="element-7" />
      <Audience data-id="element-8" />
      <InsideLook data-id="element-9" />
      <PricingCards data-id="element-10" />
      <Guarantee data-id="element-11" />
      <FAQ data-id="element-12" />
      <FinalCTA data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}